// extracted by mini-css-extract-plugin
export default {"container":"Card_container__DbXh1","header":"Card_header__XcNvs"};